import 'reflect-metadata'; // Import only once
import { container } from 'inversify-props';
import AuthService from './impl/AuthService';
import IAuthService from './IAuthService';

export default class ServiceConfiguration {
    constructor() {

    }

    configureServices() {
        container.addSingleton<IAuthService>(AuthService, 'AuthService');
    }
}
